/**
 * Formats a Date object to YYYY-MM-DD string using local timezone.
 *
 * This avoids the common off-by-one bug that occurs when using
 * toISOString() which converts to UTC before extracting the date.
 *
 * @param date - The Date object to format
 * @returns Date string in YYYY-MM-DD format (local timezone)
 *
 * @example
 * // User in PST selects Dec 15, 2024
 * const date = new Date(2024, 11, 15); // midnight local time
 * formatDateForStorage(date); // "2024-12-15" ✓
 * date.toISOString().split("T")[0]; // "2024-12-14" ✗ (UTC conversion issue)
 */
export function formatDateForStorage(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
